import React, {useEffect, useRef, useState} from "react"
import {api} from "../../../api/api";
import styled from "styled-components";

const PollContentBlockWrapper = styled.div`
  display: block;
  height: calc(100% - 50px);
`

const PollContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.internalHeight ? "flex-start" : "center"};
  height: calc(100% - 30px - 20px)
`

const PollButtonBlock = styled.div`
  max-width: 280px;
  width: 320px;
  margin: auto;
`

const PollButton = styled.button`
  width: 100%;
  margin-bottom: 10px;
  outline: none;
  border: none;
  font-size: 18px;
  line-height: 20px;
  color: #fff;
  padding: 10px 0;
  background-color: #6f1787;
  border-radius: 20px;
  cursor: pointer;
`

const PollQuestion = styled.p`
  font-size: 24px;
  line-height: 26px;
  font-weight: 600;
  text-align: center;
  color: #fff;
`

const PollContent = ({question, options, setFlag, nextFunc}) => {
    const externalBlockRef = useRef()
    const internalBlockRef = useRef()
    const [internalBlock, setInternalBlock] = useState(false)

    useEffect(() => {
        const internal = internalBlockRef.current.clientHeight
        const external = externalBlockRef.current.clientHeight

        if (internal > external) {
            setInternalBlock(true)
        }
    }, [])

    const pollOptionSelect = (poll_id, opt_id) => {
        api.votePolls(poll_id, opt_id).finally(nextFunc)
    }

    return (
        <PollContentBlockWrapper>
            <PollContentBlock
                ref={externalBlockRef}
                internalHeight={internalBlock}
            >
                <div ref={internalBlockRef}>
                    <PollQuestion>{question}</PollQuestion>
                    {
                        options.map((opt) => (
                            <PollButtonBlock key={`answer-${opt.id}`}>
                                <PollButton
                                    onClick={() => pollOptionSelect(opt.poll_id, opt.id)}
                                >{opt.name}</PollButton>
                            </PollButtonBlock>
                        ))
                    }
                </div>
            </PollContentBlock>
        </PollContentBlockWrapper>
    )
}

export default PollContent